export default __webpack_public_path__ + "static/media/bg-chat.2ad2bd83.png";